const UTMParamKeys = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_entry_page',
  'utm_referrer',
] as const;
type UTMParamType = (typeof UTMParamKeys)[number];
type UTMRecord = { [key in UTMParamType]?: string };

export type UTMParams = {
  campaign: UTMRecord;
};

export const getUTMParams = (): UTMParams | {} => {
  const params = new URLSearchParams(window.location.search);
  const campaign: UTMRecord = {};

  params.forEach((value, key) => {
    if (UTMParamKeys.includes(key as UTMParamType)) {
      campaign[key as UTMParamType] = value;
    }
  });

  return Object.keys(campaign).length > 0 ? { campaign } : {};
};
